import Board from "./Board";
import WithOnlyBackButton from "src/pods/ideas/components/WithOnlyBackButton";
import { DicussTopic } from "src/pods/ideas/data/getDiscussTopics";
import { Board as BoardType, Lesson, Slide } from "src/pods/ideas/data/types";

export type ToolkitBoardProps = {
  board: BoardType;
  displayDiscussCard?: (discuss: DicussTopic) => void;
  displayVideoCard?: (watch: Slide, lesson: Lesson, board: BoardType) => void;
};

/**
 * @param   {Object} props
 * @returns {ReactElement}
 */
export default function ToolkitBoard(props: ToolkitBoardProps) {
  return (
    <WithOnlyBackButton>
      <Board
        board={props.board}
        displayDiscussCard={props.displayDiscussCard}
        displayVideoCard={props.displayVideoCard}
      />
    </WithOnlyBackButton>
  );
}
